// Libraries
import styled from 'styled-components'

interface IProps {
  $isError?: boolean;
}

export const WrapInput = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 25px;
  margin-bottom: 10px;
`

export const StyledInput = styled.input`
  width: 100%;
  padding: 20px;
  font-family: "Avenir Next Regular", sans-serif;
  font-size: 18px;
  line-height: 19px;
  color: ${({ $isError: isError }: IProps) => isError ? '#E20004' : 'white'};
  background-color: rgba(255, 255, 255, .2);
  border: 1px solid #fff;
  box-sizing: border-box;
  letter-spacing: 0.8px;
  
  ::placeholder {
    font-size: 14px;
    color: ${({ $isError: isError }: IProps) => isError ? '#E20004' : 'white'};
  }
  :focus {
    outline-color: #00a2ff;
  }

  :-webkit-autofill,
  :-webkit-autofill:hover,
  :-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0 1000px rgba(255, 255, 255, .3) inset;
    transition: background-color 5000s ease-in-out 0s;
    -webkit-text-fill-color: white;
    font-size: 16px;
    font-style: normal;
  }
`;

export const Wrap = styled.div`
  position: relative;
`;

export const ErrorText = styled.p`
  color: #e20004;
  position: absolute;
  top: -25px;
  right: 0;
`;